//@flow

import {useState, useEffect, useCallback} from 'react';

import {getDefaultInformationFields} from '../constants';

import type {InformationField} from '../constants';
import type {CustomerComplaintSettingResponse} from '../promises';

export function useInformationFields(
  setting: ?CustomerComplaintSettingResponse,
  countryCode: ?string
) {
  const [informationFields, setInformationFields] = useState<
    InformationField[]
  >([]);

  useEffect(() => {
    if (!setting) return;

    const defaultFields = getDefaultInformationFields(countryCode);
    const savedFields = setting.informationFields || [];
    const mergedFields = defaultFields.map(defaultField => {
      const savedField = savedFields.find(
        field => field.label === defaultField.label
      );
      return savedField || defaultField;
    });

    setInformationFields(mergedFields);
  }, [setting, countryCode]);

  const updateFieldValue = useCallback((label: string, value: string) => {
    setInformationFields(prevFields =>
      prevFields.map(field =>
        field.label === label ? {...field, value} : field
      )
    );
  }, []);

  const getInformationFieldsPayload = useCallback(
    () => informationFields.filter(field => field.value.trim().length > 0),
    [informationFields]
  );

  return {informationFields, updateFieldValue, getInformationFieldsPayload};
}
